// extracted by mini-css-extract-plugin
export var banner = "_h1-0";
export var closeButton = "_h1-2";
export var greenCheckmark = "_h1-3";
export var hereLink = "_h1-4";
export var titleIcon = "_h1-1";